import * as yup from 'yup';
import { isTarifgruppeBeamter } from '@/features/Sparten/phv/formConfigs/sharedRenderConditions';

export const phvSchema = yup.object({
  vorschaden: yup.string().default('').required(),
  demvRabattiert: yup.boolean().default(true),
  tarifgruppe: yup.string().default('').required(),
  laufzeit: yup.string().default('').required(),
  zahlweise: yup.string().default('').required(),
  deckungssumme: yup.string().default('').required(),
  selbstbeteiligung: yup.string().default('').required(),
  tarifart: yup.string().default('').required(),
  kinderUnter7: yup.boolean().default(true),
  diensthaftpflicht: yup.boolean().default(false),
  abhandengekommeneGegenstaende: yup.string().default(''),
  dienstfahrzeugRegress: yup.boolean().default(false),
  dienstHundeHaftpflicht: yup.string().default(''),
  dienstPferdeHaftpflicht: yup.string().default(''),
  dienstschluessel: yup.string().default(''),
  erweiterteVermoegensschadenDeckung: yup.string().default(''),
  geraeteHaftpflicht: yup.boolean().default(false),
  kassenfehlbetraege: yup.string().default(''),
  regressHaftpflicht: yup.string().default(''),
  schadenEigentumSchule: yup.string().default(''),
  taetigkeit: yup
    .string()
    .default('')
    .when('diensthaftpflicht', {
      is: (diensthaftpflicht: boolean) =>
        diensthaftpflicht && isTarifgruppeBeamter(),
      then: yup.string().default('').required().notOneOf(['emptyDefault']),
    }),
  diensteigenschaft: yup.string().when({
    is: () => isTarifgruppeBeamter(),
    then: yup.string().default('').required().notOneOf(['emptyDefault']),
  }),
  zugangsweg: yup.string().when({
    is: () => isTarifgruppeBeamter(),
    then: yup.string().default('').required().notOneOf(['emptyDefault']),
  }),
});
